function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{opacity:0.8;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "a",
  transform: "translate(-374.081 -283.5)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M382.618,296.781c-.044-4.042,0-9.106,1.688-12.926.089-.178-.044-.355-.355-.355-.222,0-.355.089-.4.222-1.466,3.776-1.6,7.6-1.644,11.46-.533-1.2-1.066-2.621-1.777-4.62a34.05,34.05,0,0,1-1.6-6.263q-.067-.4-.666-.4c-.4,0-.622.178-.622.444a17.267,17.267,0,0,0,.222,2.31c-.089,3.2-.489,7.64-1.777,10.483-.089.178-.222.311-.311.311-.178,0-.355-.267-.622-1.022a.347.347,0,0,0-.355-.178c-.222,0-.355.133-.311.311.666,2,.8,2.488,1.421,2.488a.833.833,0,0,0,.844-.666c1.11-2.621,1.466-6.174,1.643-9.239a42.153,42.153,0,0,0,3.331,8.528.914.914,0,0,0,.844.444c.622,0,.933-.267.711-.8l-.267-.533",
  transform: "translate(0 0)"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M404.264,306.038c-.222.178-.355.622-.577.622-.178,0-.355-.444-.489-1.244a37.87,37.87,0,0,1-.311-9.372c.044-.222-.044-.311-.267-.311a.333.333,0,0,0-.355.222c-1.022,2.665-2.132,5.774-2.754,7.729-.089-.8-.355-2.221-.711-3.776a38.085,38.085,0,0,1-.844-4.708c-.044-.267-.222-.4-.622-.4s-.622.178-.577.444c.089.533.178,1.066.222,1.555-.4,3.687-1.244,9.461-3.02,12.571-.089.178,0,.355.311.4a.394.394,0,0,0,.444-.178,29.673,29.673,0,0,0,2.665-9.772v-.089c.044.4.666,6.174,1.066,8.351a.3.3,0,0,0,.311.222c.266,0,.355-.133.355-.222.666-2.843,1.333-5.241,2-7.285a46.584,46.584,0,0,0,.577,6.4c.222,1.066.533,1.466,1.022,1.466.533,0,1.777-1.421,1.866-2C404.709,306.038,404.442,305.86,404.264,306.038Z",
  transform: "translate(-11.031 -6.281)"
}));

var SvgNmSignatureBlackRgb = function SvgNmSignatureBlackRgb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 19.5,
      height: 20,
      viewBox: "0 0 19.5 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgNmSignatureBlackRgb, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/NMSignature_Black_RGB.e6a0a9dc.svg";
export { ForwardRef as ReactComponent };